export const FILTER_BY_TIME = [
  { value: 0, label: 'Last week', type: 'week', amount: 1 },
  { value: 1, label: 'Last month', type: 'week', amount: 4 },
  { value: 2, label: 'Last 3 months', type: 'week', amount: 12 },
  { value: 3, label: 'Last 6 months', type: 'week', amount: 24 },
  { value: 4, label: 'Last year', type: 'week', amount: 52 },
  { value: 5, label: 'All time', type: 'week', amount: 999999 },
];
